import { useEffect, useRef, useState } from 'react'
import { isHubDown, useConnection, useHubWaiting } from '../state/connection'
import { Loader } from './Loader'

/** How long "Back online" stays up before the banner gets out of the way. */
const CONFIRM_MS = 2000

/**
 * Why a message is not going anywhere, said inside the conversation (spec §2): on a phone the conversation fills the
 * screen, so the list's connection pill is nowhere to be seen. Silent while the connection is good.
 */
export function ConnectionBanner() {
  const online = useConnection((s) => s.online)
  const hub = useConnection((s) => s.hub)
  const waiting = useHubWaiting()
  const live = online && !isHubDown(hub)
  // "Back online" answers a banner someone saw: a reconnect too quick to show anything is not announced either.
  const shownDown = !online || waiting
  const [confirming, setConfirming] = useState(false)
  const wasShownDown = useRef(shownDown)

  useEffect(() => {
    if (shownDown) {
      wasShownDown.current = true
      setConfirming(false)
    } else if (live) {
      if (wasShownDown.current) setConfirming(true)
      wasShownDown.current = false
    }
  }, [live, shownDown])

  useEffect(() => {
    if (!confirming) return
    const timer = setTimeout(() => setConfirming(false), CONFIRM_MS)
    return () => clearTimeout(timer)
  }, [confirming])

  if (!shownDown && !confirming) return null
  return (
    <div className={`connection-banner${live ? ' is-back' : ''}`} role="status">
      {!online ? "You're offline. Messages will send when you're back." : live ? 'Back online' : <Loader label="Reconnecting…" />}
    </div>
  )
}
